import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {GestioneProfiliComponent} from './gestione-profili';
import {CreaListinoModule} from './crea-listino/crea-listino.module';
import {GestioneListinoModule} from './gestione-listino/gestione-listino.module';

// @ngInject
const stateConfig = ($stateProvider: ng.ui.IStateProvider) => {
  $stateProvider
    .state('home.gestione-profili', {
      url: '/gestione-profili/',
      params: {
        email: 'testgg3@test.com'
      },
      ncyBreadcrumb: {
        label: 'gestione-profili',
        parent: 'home.admin'
      },
      data: {
        authorisationLevel: 2,
        pageTitle: 'gestione-profili'
      },
      views: {
        homeContent: {
          template: '<gestione-profili flex="100"></gestione-profili>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const GestioneProfiliModule: string = ng
  .module('gestione-profili', [
    'ui.bootstrap',
    uiRouter,
    CreaListinoModule,
    GestioneListinoModule
  ])
  .component('gestioneProfili', GestioneProfiliComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-profili/gestione-profili.module.ts